import React, {useCallback, useMemo} from 'react'
import './admin-applications.css'
import _ from "lodash";
import ManuallyEnterApplicationModal from './ManuallyEnterApplicationModal/ManuallyEnterApplicationModal'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import useFetch from '../hooks/useFetch'
import OnboardingCardModal2023 from '../OnboardingCardModal2023/OnboardingCardModal2023'
import ApplicationModal2024 from '../ApplicationModal2024/ApplicationModal2024'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { FinishedLady } from '../StudentOnboardingFall2023/assets/FinishedLady'
import AdminApplicationsCard from './AdminApplicationsCard/AdminApplicationsCard'
import SearchHeader from '../SearchHeader/SearchHeader'
import { FilterTypeId } from '../SearchHeader/filters-type'
import axios from 'axios'
import { getRequestHeaders } from '../api'
import AdminApplicationWorkflowModalArea2024 from './AdminApplicationWorkflowModalArea2024/AdminApplicationWorkflowModalArea'
import SimpleNotification from '../DanitComponents/Notifications/SimpleNotification'
import ModalDropdownMenuFall2023 from '../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023'
import { createTeacherOffboardingWorkflow } from '../AdminWorkflows/WorkflowModels'
import { convertSchoolNamesToAbbreviations } from '../utilityFunctions'
import CongratsModal from './CongratsModal/CongratsModal';

const AdminApplications = (props) => {
    const [openWorkflowModal2023, setOpenWorkflowModal2023] = React.useState(false)
    const [openWorkflowModal2024, setOpenWorkflowModal2024] = React.useState(false)
    const [application, setApplication] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [schools, setSchools] = React.useState([])
    const [filterState, setFilterState] = React.useState({});
    const [loadingScreen, setLoadingScreen] = React.useState(false)
    const [loadingMessage, setLoadingMessage] = React.useState('')
    const [openDropdown, setOpenDropdown] = React.useState(false)
    const [showArchived, setShowArchived] = React.useState(false)
    const [displayWaitlist, setDisplayWaitlist] = React.useState(true)
    const [filteredWorkflows, setFilteredWorkflows] = React.useState([])
    const [filteredApplications, setFilteredApplications] = React.useState([])
    const [newApplicationForm, setNewApplicationForm] = React.useState(false)
    const [archivedTally, setArchivedTally] = React.useState(0)
    const [appTally, setAppTally] = React.useState(0)
    const [congratsModal, setCongratsModal] = React.useState(false)
    const [simpleNotifaction, setSimpleNotification] = React.useState({
        show: false,
        title: 'How is this?',
        subtitle: 'This is it',
        style: {
            backgroundColor: 'bg-green-100',
            titleColor: 'text-green-800',
            subtitleColor: 'text-green-800'
        },
        approved: true,
        action: function() {
            setSimpleNotification(prev => ({...prev, show: false}));
        }
    })
    const {data: workflows, loading: gettingWorkflows, error: testError, reFetch, callPut, callDelete, pushItem, updateItem, deleteItem} = useFetch(`${baseUrl}/teacher-onboarding`, getRequestHeaders())

    const isManager = props.userData.PermissionLevel === 'manager' && props.userData.IsAdmin

    React.useEffect(() => {
        props.getApplications();
        let tempOrderedSchools = [
            {id: 'all', label: 'All Schools'},
            {id: 'mma', label: 'Mountainside'},
            {id: 'lsma', label: 'Lakeside'},
            {id: 'tma', label: 'Treeside'},
            {id: 'mor', label: 'Morningside'},
            {id: 'psma', label: 'Parkside'},
            {id: 'den', label: 'Denton'},
            {id: 'tem', label: 'Tempe'},
            {id: 'tul', label: 'Tulsa'}
        ]
        setSchools(tempOrderedSchools);
    }, [])

    React.useEffect(() => {
        let filteredWorkflows = []
        let filteredApplications = []
        workflows.forEach(workflow => {
            checkForFilter(workflow) && filteredWorkflows.push(workflow)
        })
        props.applications.forEach(app => {
            checkApplicationForFilter(app) && filteredApplications.push(app)
        })
        setFilteredWorkflows(filteredWorkflows)
        setFilteredApplications(filteredApplications)
        setArchivedTally(calculateNumberOfArchivedApplications(filteredApplications))
        setAppTally(calculateNumberOfUnArchivedApplications(filteredApplications))
        
    }, [filterState])

    const createInstrumentFilterOptions = useCallback(() => {
        let instruments = props.applications &&
        _.uniqBy(
          props.applications.reduce((acc, app) => {
            return [
              ...acc,
              ...app.key13app.map((instrument) => {
                return {
                  id: instrument.id,
                  label: instrument.name,
                  group: instrument.instrumentGroup,
                };
              }),
            ];
          }, []),
          (x) => x.id
        )
        let workflowInst = workflows && 
        _.uniqBy(
            workflows.reduce((acc, work) => {
              return [
                ...acc,
                ...work.instrumentList.map((instrument) => {
                  return {
                    id: instrument.id,
                    label: instrument.name,
                    group: instrument.instrumentGroup,
                  };
                }),
              ];
            }, []),
            (x) => x.id
          )
          //combine the two arrays
            instruments = instruments.concat(workflowInst)
          return instruments
    }, [props.applications, workflows])

    const filters = useMemo(() => [
        //isManager && 
        {
            id: "instrument",
            label: "Instrument",
            type: FilterTypeId.Dropdown,
            options: createInstrumentFilterOptions()
          },
        {
            id: "school",
            label: "School",
            type: FilterTypeId.SelectDropDown,
            options: schools ? schools : [],
          }
    ], [schools, createInstrumentFilterOptions])
    
    const columns = [
        {
            title: 'WAITLIST',
            filterName: 'waitlist',
            dropDownMenuOptions: [
                {
                    label: displayWaitlist ? 'Hide' : 'Show',
                    onClick: () => setDisplayWaitlist(!displayWaitlist)
                },
            ],
            total: true
        },
        {
            title: 'APPLICATIONS',
            filterName: 'applications',
            dropDownMenuOptions: [
                {
                    label: '+ New Applicant',
                    onClick: () => setNewApplicationForm(true)
                },
            ],
            total: true
        },
        {
            title: 'INTERVIEWING',
            filterName: 'interviewing',
            dropDownMenuOptions: [],
            total: true
        },
        {
            title: 'ONBOARDING',
            filterName: 'onboarding',
            dropDownMenuOptions: [],
            total: true
        },
        {
            title: 'OFFBOARDING',
            filterName: 'offboarding',
            dropDownMenuOptions: [
                {
                    label: 'Offboard Teacher',
                    onClick: () => createTeacherOffboardingWorkflow(setLoading, pushItem, setOpenWorkflowModal2024)
                }
            ],
            total: true
        }
    ]

    const sameSchool = (app) => {
        return app.key14app === changeAbbreviationToSchoolName(props.userData.School)
    }

    const changeAbbreviationToSchoolName = (abbreviation) => {
        switch(abbreviation) {
            default: return ''
            case 'mma': return 'Mountainside Music Academy'
            case 'lsma': return 'Lakeside Music Academy'
            case 'tma': return 'Treeside Music Academy'
            case 'mor': return 'Morningside Music Academy'
            case 'psma': return 'Parkside Music Academy'
            case 'den': return 'Denton Music Academy'
            case 'tem': return 'Tempe Music Academy'
            case 'tul': return 'Tulsa Music Academy'
        }
    }

    const deleteApplication = async (id) => {
        callDelete(`${baseUrl}/applications/${id}`, props.removeApplication(id), 'id')
        setApplication(false)
        setLoadingScreen(false)
    }

    const toggleLoadingScreen = (message) => {
        if(loadingMessage !== '') {
            setLoadingMessage('') 
            setLoadingScreen(false)
        } else {
            setLoadingMessage(message)
            setLoadingScreen(true)
        }
    }

    const calculateNumberOfUnArchivedApplications = (filt) => {
        return filt.filter(app => !app.archived).length
    }

    const calculateNumberOfArchivedApplications = (filt) => {
        return filt.filter(app => app.archived).length
    }

    const checkForFilter = (workflow) => {
        let instrumentResult = false
        let schoolResult = false
        if(filterState.instrument?.length > 0) {
            for(let i = 0; i < filterState.instrument.length; i++) {
                if(workflow.instrumentList.some(instrument => instrument.id === filterState.instrument[i])) {
                    instrumentResult = true
                    break
                }
            }
        } else {
            instrumentResult = true
        }
        if(filterState.school === 'all' || !filterState.school) {
            schoolResult = true
        } else {
            filterState.school === workflow.whichSchool && (schoolResult = true)
        }
        return instrumentResult && schoolResult && workflow
    }

    const checkApplicationForFilter = (app) => {
        let instrumentResult = false
        let schoolResult = false
        if(filterState.instrument?.length > 0) {
            for(let i = 0; i < filterState.instrument.length; i++) {
                if(app.key13app.some(instrument => instrument.id === filterState.instrument[i])) {
                    instrumentResult = true
                    break
                }
            }
        } else {
            instrumentResult = true
        }
        if(filterState.school === 'all' || !filterState.school) {
            schoolResult = true
        } else {
            filterState.school === convertSchoolNamesToAbbreviations(app.key14app) && (schoolResult = true)
        }
        return instrumentResult && schoolResult && app
    }

    return (
        <div className="admin-applications-page__wrapper">
            <SimpleNotification title={simpleNotifaction.title} subtitle={simpleNotifaction.subtitle} action={simpleNotifaction.action} show={simpleNotifaction.show} style={simpleNotifaction.style} approved={simpleNotifaction.approved} />
            {congratsModal && <CongratsModal setCongratsModal={setCongratsModal} />}
            <SearchHeader title= "Teacher Onboarding" filters={filters} onChangeFilters={(filterState) => setFilterState(filterState)} clearAll={true}  />
            {loadingScreen && <NewLoadingScreen message={loadingMessage} />}
            {newApplicationForm && <ManuallyEnterApplicationModal setNewApplicationForm={setNewApplicationForm} setApplications={props.setApplications} />}
            {openWorkflowModal2024 && <AdminApplicationWorkflowModalArea2024 workflow={openWorkflowModal2024} updateItem={updateItem} deleteItem={deleteItem} setOpenWorkflowModal2024={setOpenWorkflowModal2024} createNoteFunc={props.createNoteFunc} userData={props.userData} setCongratsModal={setCongratsModal} />}
            <div className="admin-applications__column-wrapper">
                {columns.map(column =>
                    <div key={column.title} className="admin-applications__column">
                        <div className="admin-applications__column__header">
                            <div className="admin-applications__column__title">{column.title} {column.filterName === 'applications' && `(${appTally})`}</div>
                            {column.dropDownMenuOptions.length > 0 && <BsThreeDotsVertical cursor={'pointer'} color='#94A3B8' onClick={() => setOpenDropdown(column.title)} />}
                            {openDropdown === column.title && <ModalDropdownMenuFall2023 menuItems={column.dropDownMenuOptions} setOpenDropdown={setOpenDropdown} />}
                        </div>
                        <div className={column.filterName === 'waitlist' ? "admin-applications__column__waitlist" : "admin-applications__column__scroll-area"}>
                            {column.filterName !== 'waitlist' ? 
                                <div>
                                    {column.filterName === 'applications' && filteredApplications?.map(app => !app.archived && <AdminApplicationsCard key={app.id} toggleApplication={setApplication} application={app} isApp={true} />)}
                                    {filteredWorkflows.map(workflow => workflow.whichList === column.filterName && <AdminApplicationsCard key={workflow.todoId} application={workflow} isApp={false} setOpenWorkflowModal2024={setOpenWorkflowModal2024} />)}
                                </div>
                            :
                                <div className='admin-applications__waitlist-column__double-wrapper'>
                                    {displayWaitlist && 
                                        <div className='admin-applications__waitlist-column__top' style={showArchived ? {height: '300px'} : {height: '500px'}}>
                                            {filteredWorkflows.map(workflow => workflow.whichList === column.filterName && <div><AdminApplicationsCard key={workflow.todoId} application={workflow} isApp={false} setOpenWorkflowModal2024={setOpenWorkflowModal2024} /></div>)}
                                        </div>
                                    }
                                    <div className="admin-applications__column__header">
                                        <div className="admin-applications__column__title archived-split" style={{color: '#94A3B8'}}>
                                            <div>ARCHIVED ({archivedTally})</div>
                                            <div className='admin-archived__show-btn' onClick={() => setShowArchived(!showArchived)}>{showArchived ? 'hide' : 'show'}</div>
                                        </div>
                                    </div>
                                    {showArchived && 
                                        <div className='admin-applications__waitlist-column__bottom' style={displayWaitlist ? {height: '300px'} : {height: '500px'}}>{column.filterName === 'waitlist' && filteredApplications?.map(app => app.archived && <div><AdminApplicationsCard key={app.id} toggleApplication={setApplication} application={app} isApp={true} /></div>)}
                                        </div>}
                                </div>
                            }
                        </div>
                    </div>
                )}
            </div>
            {application && <ApplicationModal2024 
                setApplication={setApplication} 
                application={application} 
                deleteApplication={deleteApplication} 
                toggleLoadingScreen={toggleLoadingScreen} 
                setError={setError} 
                pushItem={pushItem}
                createNoteFunc={props.createNoteFunc}
                userData={props.userData}
                setApplications={props.setApplications}
                setSimpleNotification={setSimpleNotification}
            />}
            {/* {application && <ApplicationModal setApplication={setApplication} application={application} deleteApplication={deleteApplication} toggleLoadingScreen={toggleLoadingScreen} setError={setError} pushItem={pushItem}/>} */}
            {openWorkflowModal2023 && <OnboardingCardModal2023 openWorkflowModal2023={openWorkflowModal2023} setOpenWorkflowModal2023={setOpenWorkflowModal2023} setShowNotes={props.setShowNotes} updateItem={updateItem} deleteItem={deleteItem} />}
            {error && <ErrorPopup error={error} setError={setError}/>}
        </div>
    )
}

export default AdminApplications